module.exports = __webpack_public_path__ + "img/dasco-logo.77fdf180.svg";